// extracted by mini-css-extract-plugin
module.exports = {"HeaderDesktop":"header-desktop_HeaderDesktop__ren1K"};